// Unlike authenticated screens, this wrapper also renders the sign-in route,
// where no current practitioner exists yet.
// oxlint-disable-next-line no-restricted-imports
import { useMedplumProfile } from '@medplum/react-hooks'
import { featureFlagDefaultValues } from '@seen/core/featureFlags'
import { getReferenceString } from '@seen/core/references'
import { FeatureFlagProvider, Loader } from '@seen/react'
import type { JSX, ReactNode } from 'react'
import { useFeatureFlagValues } from '#src/api/featureFlags.ts'

export function FeatureFlagBootstrap({
  children,
}: {
  children: ReactNode
}): JSX.Element {
  const profile = useMedplumProfile()
  const practitionerReference =
    profile?.resourceType === 'Practitioner'
      ? getReferenceString(profile)
      : undefined
  const values = useFeatureFlagValues(practitionerReference)

  if (!practitionerReference) {
    return (
      <FeatureFlagProvider values={featureFlagDefaultValues}>
        {children}
      </FeatureFlagProvider>
    )
  }

  if (values.isPending) {
    return <Loader />
  }

  return (
    <FeatureFlagProvider values={values.data ?? featureFlagDefaultValues}>
      {children}
    </FeatureFlagProvider>
  )
}
